import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Radio, RadioGroup, FormControlLabel, Button
} from '@mui/material';

interface RoommateData {
  civility: 'M' | 'Mme';
  firstname: string;
  lastname: string;
  birthdate: string;
}

interface RoommateFormModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  roommateData: RoommateData;
  setRoommateData: (data: RoommateData) => void;
  t: (key: string) => string;
}

const RoommateFormModal: React.FC<RoommateFormModalProps> = ({
  open,
  onClose,
  onSubmit,
  roommateData,
  setRoommateData,
  t
}) => (
  <Dialog open={open} onClose={onClose} >
    <DialogTitle>{t('step3.add_flatmate')}</DialogTitle>
    <DialogContent>
      <RadioGroup
        row
        value={roommateData.civility}
        onChange={(e) =>
          setRoommateData({ ...roommateData, civility: e.target.value as 'M' | 'Mme' })
        }
      >
        <FormControlLabel value="M" control={<Radio />} label={t('step3.modal.male')} />
        <FormControlLabel value="Mme" control={<Radio />} label={t('step3.modal.female')} />
      </RadioGroup>
      <TextField
        label={t('step3.modal.firstname')}
        fullWidth
        margin="normal"
        value={roommateData.firstname}
        onChange={(e) => setRoommateData({ ...roommateData, firstname: e.target.value })}
      />
      <TextField
        label={t('step3.modal.lastname')}
        fullWidth
        margin="normal"
        value={roommateData.lastname}
        onChange={(e) => setRoommateData({ ...roommateData, lastname: e.target.value })}
      />
      <TextField
        label={t('step3.modal.birthdate')}
        type="date"
        fullWidth
        margin="normal"
        InputLabelProps={{ shrink: true }}
        value={roommateData.birthdate}
        onChange={(e) => setRoommateData({ ...roommateData, birthdate: e.target.value })}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>{t('step3.modal.cancel')}</Button>
      <Button
        onClick={onSubmit}
        disabled={
          !roommateData.firstname ||
          !roommateData.lastname ||
          !roommateData.birthdate
        }
      >
        {t('step3.modal.add')}
      </Button>
    </DialogActions>
  </Dialog>
);

export default RoommateFormModal;